import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChLoadingComponent } from './ch-loading.component';


export class ChLoadingModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [ChLoadingComponent],
  exports: [ChLoadingComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
